import { observer } from 'mobx-react-lite';

import { ChartRig, RigsGroup, TemporaryChartRig } from '../../../presets/drilling-rigs-chart/entities';
import type { RigsChartStore } from '../../../presets/drilling-rigs-chart/rigs-chart.store';
import type { Viewport } from '../../../shared/viewport/viewport';
import { RigsSorting } from '../../rigs-sorting/rigs-sorting';

import styles from './data-items.module.scss';
import { EditingRigRow } from './editing-rig-row';
import { EditingTemporaryRigRow } from './editing-temporary-rig-row';
import { GhostRow } from './ghost-row';

interface Props {
  item: RigsChartStore.ViewItem;
  verticalViewport: Viewport;
}

export const EditingRigsDataBackgroundItem = observer(function EditingRigsDataBackgroundItem({
  item,
  verticalViewport,
}: Props) {
  if (item instanceof ChartRig || item instanceof RigsGroup) {
    return <EditingRigRow item={item} verticalViewport={verticalViewport} />;
  }

  if (item instanceof TemporaryChartRig) {
    return <EditingTemporaryRigRow item={item} verticalViewport={verticalViewport} />;
  }

  if (RigsSorting.isRigGhost(item)) {
    return <GhostRow item={item} verticalViewport={verticalViewport} className={styles.row} />;
  }

  if (RigsSorting.isRigsGroupGhost(item)) {
    return <GhostRow item={item} verticalViewport={verticalViewport} className={styles.rowHeader} />;
  }

  return null;
});
